<template>
	<div v-if="isCodeArive === false" class="auth-form">
		<div class="text-center logo"><img :src="stylePathToLogo || '/static/img/logo/logo.png'" /></div>

		<h4 class="text-center">{{ 'login/password_reminder' | ftc }}</h4>

		<template v-if="errorWithLogout">

			<div class="w5-field text-center alert alert-danger margin-20-0">
				<p style="margin: 0; padding: 10px;" v-withSafeTags="errorWithLogout"></p>
			</div>
			<button type="button" class="btn btn-submit btn-primary btn-block" @click.prevent="logOut">{{ 'login/logout' | ftc }}</button>

		</template>
		<template v-if="!errorWithLogout">

			<fieldset :disabled="form_Loading">
			<div class="w5-field" v-show="successMessage === false">
				<span class="al" :class="{ animated: animatedEmail, focused: isFocusedEmail, unfocused: !isFocusedEmail }">{{ 'main/email' | ftc }}<span class="required-field"> *</span></span>
				<input type="text" aria-describedby="emailHelp" :placeholder="`main/email *` | ftc" :class="{ haserror: form_ErrorMessage }"
				ref="email" v-model="email" @focus="OnFocus" @blur="OnBlur" @keyup="OnKeyUp">
				<div class="alert alert-danger w5-error-block" role="alert" v-show="form_ErrorMessage !== false" style="margin-bottom: 0" v-withSafeTags="localeFtc(form_ErrorMessage)"></div>
			</div>
			</fieldset>
			
			<div class="w5-field text-center" v-show="successMessage === false">
				<img src="/static/img/loading32.gif" v-show="form_Loading" />
				<button class="btn btn-submit btn-primary btn-block" type="button"
				ref="button" @click="request" v-show="!form_Loading">{{ 'login/remind' | ftc }}</button>
			</div>

			<div class="w5-field text-center alert alert-success margin-20-0" v-show="successMessage !== false">
				<p style="margin: 0; padding: 10px;" v-withSafeTags="successMessage"></p>
			</div>

			<div class="w5-field" v-show="!form_Loading">
				<span v-show="successMessage === false">{{ 'login/remembered' | ftc }}</span> <router-link to="/login">{{ 'main/enter' | ftc }}</router-link>
			</div>

		</template>
	</div>

	<div v-else class="user-forget-form">
		<h2>{{ 'forget/title' | ftc }}</h2>
		<!-- блок с ошибкой -->
		<div v-show="isCodeError !== ''" class="alert alert-danger code-error" role="alert"><p v-withSafeTags="localeFtc(isCodeError)"></p></div>
		<!-- блок с успехом -->
		<div v-show="successMessage !== '' && successMessage !== false" class="alert alert-success code-success" role="alert">{{ successMessage | ftc }}</div>
		<!-- ссылка на главную -->
		<br>
		<div class="text-left code-link">{{ 'login/return_to_main_page1' | ftc }} <a href="/" :title="'login/return_to_main_page2' | ftc">{{ 'login/return_to_main_page2' | ftc }}</a></div>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'rememberForm',
	//=========================================================================
	// свойства компонента
	//=========================================================================
	data() {
		return {
			email: '',
			successMessage: false,
			// по умолчанию выключена, обычно включается при первом фокусе на поле
			animatedEmail: false,
			// в фокусе поле или нет
			isFocusedEmail: false,
			// если получен код
			isCodeArive: false,
			isCodeError: '',
			isCode: null,
			// ошибка с разлогином
			errorWithLogout: ''
		}
	},
	//=========================================================================
	// создание компонента
	//=========================================================================
	created() {
		// если это пришли по ссылке напоминания пароля
		if (this.$route.path === '/user/forget')
		{
			// ставим признак тогда что это страница обработки кода
			this.isCodeArive = true

			// должен быть задан код - первое свойство объекта query
			let _keys = Object.keys(this.$route.query)
			// если кода нет - выводим ошибку и все
			if (!_keys.length)
			{
				this.isCodeError = 'forget/notcode'
				return
			}

			// получаем код
			let _code = _keys[0]
			// проверка корректности кода
			if (_code === undefined || _code === null || String(_code).trim() === '')
			{
				this.isCodeError = 'forget/notcode'
				return
			}

			// запоминаем код
			this.isCode = _code
		}
	},
	//=========================================================================
	// компонент примонтирован в DOM
	//=========================================================================
	mounted() {
		// если задан код для напоминания пароля
		if (this.isCodeArive && this.isCode)
		{
			// готовим url запроса
			let _url = '/user/forget?' + this.isCode

			// запрос
			this.forms_GetThenPost(_url, null,
				// успех
				data => {
					if (data && typeof data === 'object' && 'status' in data && data['status'] === 'ok' && data.content)
					{
						// покажем сообщени
						this.successMessage = data.content
						// на этом все
						return
					}

					// ошибка
					this.isCodeError = this.localeFtc('<b>main/error_desc</b><br>')
					if (data && typeof data === 'object' && data.content) this.isCodeError += data.content
					else this.isCodeError = this.isCodeError.replace(':', '.').replace(/strong/g, 'span')
				},
				// неудача
				error => {
					this.isCodeError = this.localeFtc('<b>main/error_desc</b><br>')
					let _cnt = 0
					if (error.status === 'error')
					{
						for (let k in error) if (error.hasOwnProperty(k))
						{
							this.isCodeError += error[k] + ' <br> '
							_cnt++
						}
					}

					if (_cnt === 0)
						this.isCodeError = this.isCodeError.replace(':', '.').replace(/strong/g, 'span')
					else if (_cnt > 1)
						this.isCodeError = this.isCodeError.replace('Возникла ошибка', 'Возникли ошибки')
				}
			)
		}
	},
	//=========================================================================
	// функции компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// событие: фокус на поле формы
		//---------------------------------------------------------------------
		OnFocus(e) {
			// при первом фокусе - включаем анимацию
			this.animatedEmail = true
			// добавляем класс "focused"
			this.isFocusedEmail = true
			this.form_ErrorMessage = false
			this.removeErrorBorder_OnFocus(e)
		},
		//---------------------------------------------------------------------
		// событие: потеря фокуса полем формы
		//---------------------------------------------------------------------
		OnBlur(e) {
			// убираем класс "focused" только если значение пустое
			if (e && e.target)
			{
				if (e.target.value === null || e.target.value === undefined || e.target.value === '')
					this.isFocusedEmail = false
			}
			this.form_ErrorMessage = false
			this.removeErrorBorder_OnFocus(e)
		},
		//---------------------------------------------------------------------
		// событие: клавишы по полю
		//---------------------------------------------------------------------
		OnKeyUp(e) {
			this.form_ErrorMessage = false
			this.removeErrorBorder_OnFocus(e)
			this.enterOnInput(e)
		},
		//---------------------------------------------------------------------
		// запрос на регистрацию
		//---------------------------------------------------------------------
		request() {
			// обнуляем ошибку
			this.form_ErrorMessage = false

			// проверка полей
			if (this.email === null || this.email === undefined || String(this.email).trim() === '' || !Helper.validateEmail(this.email))
			{
				this.form_ErrorMessage = this.localeFtc('validators/error_email')
				return
			}

			// готовим объект запроса и url запроса
			let _obj = {
				'email': this.email
			}
			let _url = '/user/forget'

			// запрос на аутентификацию
			this.forms_GetThenPost(_url, _obj,
				// успех
				(data) => {
					// обнуляем поле
					this.email = ''

					// покажем сообщени
					this.successMessage = this.localeFtc('forget/success<br><br> forget/email_sent')
				},
				// неудача
				(error) => {
					let _msg = this.localeFtc('main/validation_error')

					// если это 403 Blacklisted
					if (error && error.status === 403 && error.data && error.data.content === 'Blacklisted')
					{
						// ставим текст сообщения
						_msg = this.localeFtc('login/blacklisted')
					}

					// если есть ошибка по полю email
					if (error && typeof error === 'object' && error['email'])
					{
						if (Array.isArray(error['email']) && error['email'].length) _msg = this.localeFtc(error['email'][0])
						else _msg = this.localeFtc(error['email'])
					}

					if (error && typeof error === 'object' &&
						error.data &&
						error.data.status === 'error' && error.data.content && error.data.title &&
						error.data.content === 'user/need_logout')
					{
						this.errorWithLogout = '<b>' + this.localeFtc(error.data.title) + '</b><br><br>' + this.localeFtc(error.data.content)
						return
					}

					this.addClass(this.$refs['email'].parentNode, 'has-error')
					this.form_ErrorMessage = this.localeFtc(_msg)
				}
			)
		},
		//---------------------------------------------------------------------
		// процедура выхода
		//---------------------------------------------------------------------
		logOut() {
			// запрос на выход из системы
			this.forms_GetThenPost('/logout', false,
				// успех
				(data) => {
					this.$store.commit('dropAuth')
					this.$router.push('/login')
				},
				// провал
				(data) => {
					this.$router.push('/')
				}
			)
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.user-forget-form {
	text-align: center;
}

.user-forget-form > .code-error,
.user-forget-form > .code-success,
.user-forget-form > .code-link {
	margin: auto;
	width: 50%;
}

@media (max-width: 767px) {
	.user-forget-form > .code-error,
	.user-forget-form > .code-success,
	.user-forget-form > .code-link {
		width: 300px;
	}
}

</style>



// WEBPACK FOOTER //
// Remember.vue?49a817f9